import request from '@/utils/request';
import { roleEndpoint } from '@/constants/urls';

const get = (code) => request({
  url: `${roleEndpoint(code)}/actions`,
  method: 'GET',
});

const update = (code, roleActions) => request({
  url: `${roleEndpoint(code)}/actions`,
  data: { role_actions: roleActions },
  method: 'PUT',
});

const RoleActionsService = {
  get,
  update,
};

export default RoleActionsService;
